var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{attrs:{"id":"main"}},[_c('router-view',{on:{"back":_vm.handleBack}}),_vm._v(" "),_c('Snackbar')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }